export const typeStepsCodes = {
  invoiceReady: 'invoiceReady',
  goOutVehicleReady: 'goOutVehicleReady',
  printDeliveryReady: 'printDeliveryReady'
}
